import {NgOptimizedImage} from "@angular/common";
import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {MatToolbar, MatToolbarRow} from "@angular/material/toolbar";
import {SecurityService} from "@menu-security";
import {DevFeatureDirective, NON_PROD} from "../../../services/directives/dev-feature.directive";
import {EnvironmentBarComponent} from "../../components/environment-bar/environment-bar.component";
import {LanguagePickerComponent} from "../../components/language-picker/language-picker.component";
import {NavigationTabsComponent} from "../../components/navigation-tabs/navigation-tabs.component";
import {NotificationsComponent} from "../../components/notifications/notifications.component";

import {ProfileButtonComponent} from "../../components/profile-button/profile-button.component";
import {RolePickerComponent} from "../../components/role-picker/role-picker.component";

@Component({
    selector: "app-toolbar",
    imports: [
        MatToolbar,
        MatToolbarRow,
        NgOptimizedImage,
        ProfileButtonComponent,
        EnvironmentBarComponent,
        LanguagePickerComponent,
        RolePickerComponent,
        DevFeatureDirective,
        NotificationsComponent,
        NavigationTabsComponent,

    ],
    templateUrl: "./toolbar.component.html",
    styleUrl: "./toolbar.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
    protected readonly NON_PROD = NON_PROD;

    protected readonly securityService = inject(SecurityService);
}
